/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  AssignRoleRequest,
  AttendanceDeleted,
  AttendanceListRow,
  AttendanceMonthly,
  AttendancePunched,
  AttendanceRecord,
  AttendanceSelfHistory,
  AttendanceSelfToday,
  AttendanceTodaySummary,
  AvatarCleared,
  AvatarSet,
  ChosenVehicle,
  CreateRoleRequest,
  DeleteRoleResponse,
  DeleteSettingsRolesKeyParams,
  DriverAvailability,
  DriverDelivery,
  DriverStats,
  DriverWallet,
  Employee,
  EmployeePerformance,
  ExternalDriver,
  GetAttendanceMonthlyParams,
  GetAttendanceParams,
  GetAttendanceSelfHistoryParams,
  GetAuthMeActivityParams,
  GetAuthMeStatsParams,
  GetEmployeesDriverStatsParams,
  GetEmployeesExternalDriversParams,
  GetEmployeesIdDriverWalletParams,
  GetEmployeesIdWaiterWalletParams,
  GetEmployeesPerformanceParams,
  GetEmployeesWalletsParams,
  LoggedOutEverywhere,
  MyWallet,
  PatchAttendanceIdBody,
  PatchAttendanceSelfTodayBody,
  PatchAuthMeProfileBody,
  PatchEmployeesIdApproveBody,
  PatchEmployeesIdBody,
  PatchEmployeesMyAvailabilityBody,
  PatchEmployeesMyVehicleBody,
  PostAttendanceBody,
  PostAttendanceDeviceBody,
  PostAttendanceSelfBody,
  PostAuthMeAvatarBody,
  PostAuthMePasswordBody,
  PostEmployeesBody,
  PutEmployeesIdExternalRatesBody,
  ReplaceRolePermissionsRequest,
  ReplaceRolePermissionsResponse,
  RoleDelegationsRequest,
  RoleDelegationsResponse,
  RoleOptions,
  RolePreview,
  RolePreviewRequest,
  RoleView,
  RolesOverview,
  StaffActivity,
  StaffPasswordChanged,
  StaffProfile,
  StaffProfileUpdated,
  StaffStats,
  UpdateRoleRequest,
  WaiterBackfillResult,
  WaiterWallet,
  WalletSummary,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutSettingsRolesKeyPermissionsUrl = (key: string) => {
  return `/api/v1/settings/roles/${key}/permissions`
}

/**
 * @summary Replace a role's rights, all or nothing
 */
export const putSettingsRolesKeyPermissions = async (
  key: string,
  replaceRolePermissionsRequest: ReplaceRolePermissionsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReplaceRolePermissionsResponse> => {
  return customFetch<ReplaceRolePermissionsResponse>(getPutSettingsRolesKeyPermissionsUrl(key), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replaceRolePermissionsRequest),
  })
}

export const getPutSettingsRolesKeyPermissionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsRolesKeyPermissions>>,
    TError,
    { key: string; data: ReplaceRolePermissionsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsRolesKeyPermissions>>,
  TError,
  { key: string; data: ReplaceRolePermissionsRequest },
  TContext
> => {
  const mutationKey = ['putSettingsRolesKeyPermissions']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsRolesKeyPermissions>>,
    { key: string; data: ReplaceRolePermissionsRequest }
  > = (props) => {
    const { key, data } = props ?? {}

    return putSettingsRolesKeyPermissions(key, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsRolesKeyPermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsRolesKeyPermissions>>
>
export type PutSettingsRolesKeyPermissionsMutationBody = ReplaceRolePermissionsRequest
export type PutSettingsRolesKeyPermissionsMutationError = unknown

/**
 * @summary Replace a role's rights, all or nothing
 */
export const usePutSettingsRolesKeyPermissions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsRolesKeyPermissions>>,
      TError,
      { key: string; data: ReplaceRolePermissionsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsRolesKeyPermissions>>,
  TError,
  { key: string; data: ReplaceRolePermissionsRequest },
  TContext
> => {
  return useMutation(getPutSettingsRolesKeyPermissionsMutationOptions(options), queryClient)
}
export const getPutSettingsRolesDelegationsUrl = () => {
  return `/api/v1/settings/roles/delegations`
}

/**
 * @summary Replace who may hand which role down
 */
export const putSettingsRolesDelegations = async (
  roleDelegationsRequest: RoleDelegationsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RoleDelegationsResponse> => {
  return customFetch<RoleDelegationsResponse>(getPutSettingsRolesDelegationsUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(roleDelegationsRequest),
  })
}

export const getPutSettingsRolesDelegationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putSettingsRolesDelegations>>,
    TError,
    { data: RoleDelegationsRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putSettingsRolesDelegations>>,
  TError,
  { data: RoleDelegationsRequest },
  TContext
> => {
  const mutationKey = ['putSettingsRolesDelegations']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putSettingsRolesDelegations>>,
    { data: RoleDelegationsRequest }
  > = (props) => {
    const { data } = props ?? {}

    return putSettingsRolesDelegations(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutSettingsRolesDelegationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putSettingsRolesDelegations>>
>
export type PutSettingsRolesDelegationsMutationBody = RoleDelegationsRequest
export type PutSettingsRolesDelegationsMutationError = unknown

/**
 * @summary Replace who may hand which role down
 */
export const usePutSettingsRolesDelegations = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putSettingsRolesDelegations>>,
      TError,
      { data: RoleDelegationsRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putSettingsRolesDelegations>>,
  TError,
  { data: RoleDelegationsRequest },
  TContext
> => {
  return useMutation(getPutSettingsRolesDelegationsMutationOptions(options), queryClient)
}
export const getPutEmployeesIdRoleUrl = (id: number) => {
  return `/api/v1/employees/${id}/role`
}

/**
 * @summary Move an employee into a role
 */
export const putEmployeesIdRole = async (
  id: number,
  assignRoleRequest: AssignRoleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee> => {
  return customFetch<Employee>(getPutEmployeesIdRoleUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(assignRoleRequest),
  })
}

export const getPutEmployeesIdRoleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putEmployeesIdRole>>,
    TError,
    { id: number; data: AssignRoleRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putEmployeesIdRole>>,
  TError,
  { id: number; data: AssignRoleRequest },
  TContext
> => {
  const mutationKey = ['putEmployeesIdRole']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putEmployeesIdRole>>,
    { id: number; data: AssignRoleRequest }
  > = (props) => {
    const { id, data } = props ?? {}

    return putEmployeesIdRole(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutEmployeesIdRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof putEmployeesIdRole>>
>
export type PutEmployeesIdRoleMutationBody = AssignRoleRequest
export type PutEmployeesIdRoleMutationError = unknown

/**
 * @summary Move an employee into a role
 */
export const usePutEmployeesIdRole = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putEmployeesIdRole>>,
      TError,
      { id: number; data: AssignRoleRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putEmployeesIdRole>>,
  TError,
  { id: number; data: AssignRoleRequest },
  TContext
> => {
  return useMutation(getPutEmployeesIdRoleMutationOptions(options), queryClient)
}
export const getPutEmployeesIdExternalRatesUrl = (id: number) => {
  return `/api/v1/employees/${id}/external-rates`
}

/**
 * @summary Set an external driver's rates
 */
export const putEmployeesIdExternalRates = async (
  id: number,
  putEmployeesIdExternalRatesBody: PutEmployeesIdExternalRatesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee> => {
  return customFetch<Employee>(getPutEmployeesIdExternalRatesUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putEmployeesIdExternalRatesBody),
  })
}

export const getPutEmployeesIdExternalRatesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putEmployeesIdExternalRates>>,
    TError,
    { id: number; data: PutEmployeesIdExternalRatesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putEmployeesIdExternalRates>>,
  TError,
  { id: number; data: PutEmployeesIdExternalRatesBody },
  TContext
> => {
  const mutationKey = ['putEmployeesIdExternalRates']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putEmployeesIdExternalRates>>,
    { id: number; data: PutEmployeesIdExternalRatesBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return putEmployeesIdExternalRates(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutEmployeesIdExternalRatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putEmployeesIdExternalRates>>
>
export type PutEmployeesIdExternalRatesMutationBody = PutEmployeesIdExternalRatesBody
export type PutEmployeesIdExternalRatesMutationError = unknown

/**
 * @summary Set an external driver's rates
 */
export const usePutEmployeesIdExternalRates = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putEmployeesIdExternalRates>>,
      TError,
      { id: number; data: PutEmployeesIdExternalRatesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putEmployeesIdExternalRates>>,
  TError,
  { id: number; data: PutEmployeesIdExternalRatesBody },
  TContext
> => {
  return useMutation(getPutEmployeesIdExternalRatesMutationOptions(options), queryClient)
}
export const getGetSettingsRolesUrl = () => {
  return `/api/v1/settings/roles`
}

/**
 * @summary The roles, their people and who may hand them down
 */
export const getSettingsRoles = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<RolesOverview> => {
  return customFetch<RolesOverview>(getGetSettingsRolesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsRolesQueryKey = () => {
  return [`/api/v1/settings/roles`] as const
}

export const getGetSettingsRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsRoles>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsRoles>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSettingsRolesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsRoles>>> = ({ signal }) =>
    getSettingsRoles({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsRoles>>>
export type GetSettingsRolesQueryError = unknown

export function useGetSettingsRoles<
  TData = Awaited<ReturnType<typeof getSettingsRoles>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsRoles>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsRoles>>,
          TError,
          Awaited<ReturnType<typeof getSettingsRoles>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsRoles<
  TData = Awaited<ReturnType<typeof getSettingsRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsRoles>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsRoles>>,
          TError,
          Awaited<ReturnType<typeof getSettingsRoles>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsRoles<
  TData = Awaited<ReturnType<typeof getSettingsRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsRoles>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The roles, their people and who may hand them down
 */

export function useGetSettingsRoles<
  TData = Awaited<ReturnType<typeof getSettingsRoles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsRoles>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostSettingsRolesUrl = () => {
  return `/api/v1/settings/roles`
}

/**
 * @summary Create a custom role
 */
export const postSettingsRoles = async (
  createRoleRequest: CreateRoleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RoleView> => {
  return customFetch<RoleView>(getPostSettingsRolesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createRoleRequest),
  })
}

export const getPostSettingsRolesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsRoles>>,
    TError,
    { data: CreateRoleRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsRoles>>,
  TError,
  { data: CreateRoleRequest },
  TContext
> => {
  const mutationKey = ['postSettingsRoles']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsRoles>>,
    { data: CreateRoleRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postSettingsRoles(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSettingsRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsRoles>>
>
export type PostSettingsRolesMutationBody = CreateRoleRequest
export type PostSettingsRolesMutationError = unknown

/**
 * @summary Create a custom role
 */
export const usePostSettingsRoles = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsRoles>>,
      TError,
      { data: CreateRoleRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsRoles>>,
  TError,
  { data: CreateRoleRequest },
  TContext
> => {
  return useMutation(getPostSettingsRolesMutationOptions(options), queryClient)
}
export const getPostSettingsRolesKeyPermissionsPreviewUrl = (key: string) => {
  return `/api/v1/settings/roles/${key}/permissions/preview`
}

/**
 * @summary What saving a role's rights would do, and nothing written
 */
export const postSettingsRolesKeyPermissionsPreview = async (
  key: string,
  rolePreviewRequest: RolePreviewRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RolePreview> => {
  return customFetch<RolePreview>(getPostSettingsRolesKeyPermissionsPreviewUrl(key), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rolePreviewRequest),
  })
}

export const getPostSettingsRolesKeyPermissionsPreviewMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSettingsRolesKeyPermissionsPreview>>,
    TError,
    { key: string; data: RolePreviewRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSettingsRolesKeyPermissionsPreview>>,
  TError,
  { key: string; data: RolePreviewRequest },
  TContext
> => {
  const mutationKey = ['postSettingsRolesKeyPermissionsPreview']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSettingsRolesKeyPermissionsPreview>>,
    { key: string; data: RolePreviewRequest }
  > = (props) => {
    const { key, data } = props ?? {}

    return postSettingsRolesKeyPermissionsPreview(key, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSettingsRolesKeyPermissionsPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSettingsRolesKeyPermissionsPreview>>
>
export type PostSettingsRolesKeyPermissionsPreviewMutationBody = RolePreviewRequest
export type PostSettingsRolesKeyPermissionsPreviewMutationError = unknown

/**
 * @summary What saving a role's rights would do, and nothing written
 */
export const usePostSettingsRolesKeyPermissionsPreview = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSettingsRolesKeyPermissionsPreview>>,
      TError,
      { key: string; data: RolePreviewRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSettingsRolesKeyPermissionsPreview>>,
  TError,
  { key: string; data: RolePreviewRequest },
  TContext
> => {
  return useMutation(getPostSettingsRolesKeyPermissionsPreviewMutationOptions(options), queryClient)
}
export const getGetEmployeesUrl = () => {
  return `/api/v1/employees`
}

/**
 * @summary Everybody who works here
 */
export const getEmployees = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee[]> => {
  return customFetch<Employee[]>(getGetEmployeesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesQueryKey = () => {
  return [`/api/v1/employees`] as const
}

export const getGetEmployeesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployees>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployees>>> = ({ signal }) =>
    getEmployees({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployees>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getEmployees>>>
export type GetEmployeesQueryError = unknown

export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployees>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployees>>,
          TError,
          Awaited<ReturnType<typeof getEmployees>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everybody who works here
 */

export function useGetEmployees<TData = Awaited<ReturnType<typeof getEmployees>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployees>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostEmployeesUrl = () => {
  return `/api/v1/employees`
}

/**
 * @summary Add an employee
 */
export const postEmployees = async (
  postEmployeesBody: PostEmployeesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee> => {
  return customFetch<Employee>(getPostEmployeesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postEmployeesBody),
  })
}

export const getPostEmployeesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmployees>>,
    TError,
    { data: PostEmployeesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmployees>>,
  TError,
  { data: PostEmployeesBody },
  TContext
> => {
  const mutationKey = ['postEmployees']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmployees>>,
    { data: PostEmployeesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postEmployees(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostEmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof postEmployees>>>
export type PostEmployeesMutationBody = PostEmployeesBody
export type PostEmployeesMutationError = unknown

/**
 * @summary Add an employee
 */
export const usePostEmployees = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postEmployees>>,
      TError,
      { data: PostEmployeesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postEmployees>>,
  TError,
  { data: PostEmployeesBody },
  TContext
> => {
  return useMutation(getPostEmployeesMutationOptions(options), queryClient)
}
export const getPostAuthMePasswordUrl = () => {
  return `/api/v1/auth/me/password`
}

/**
 * @summary Change your own password
 */
export const postAuthMePassword = async (
  postAuthMePasswordBody: PostAuthMePasswordBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffPasswordChanged> => {
  return customFetch<StaffPasswordChanged>(getPostAuthMePasswordUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthMePasswordBody),
  })
}

export const getPostAuthMePasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthMePassword>>,
    TError,
    { data: PostAuthMePasswordBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthMePassword>>,
  TError,
  { data: PostAuthMePasswordBody },
  TContext
> => {
  const mutationKey = ['postAuthMePassword']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthMePassword>>,
    { data: PostAuthMePasswordBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthMePassword(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthMePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthMePassword>>
>
export type PostAuthMePasswordMutationBody = PostAuthMePasswordBody
export type PostAuthMePasswordMutationError = unknown

/**
 * @summary Change your own password
 */
export const usePostAuthMePassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthMePassword>>,
      TError,
      { data: PostAuthMePasswordBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthMePassword>>,
  TError,
  { data: PostAuthMePasswordBody },
  TContext
> => {
  return useMutation(getPostAuthMePasswordMutationOptions(options), queryClient)
}
export const getPostAuthMeLogoutAllUrl = () => {
  return `/api/v1/auth/me/logout-all`
}

/**
 * @summary Sign every device out
 */
export const postAuthMeLogoutAll = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LoggedOutEverywhere> => {
  return customFetch<LoggedOutEverywhere>(getPostAuthMeLogoutAllUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostAuthMeLogoutAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthMeLogoutAll>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof postAuthMeLogoutAll>>, TError, void, TContext> => {
  const mutationKey = ['postAuthMeLogoutAll']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthMeLogoutAll>>,
    void
  > = () => {
    return postAuthMeLogoutAll(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthMeLogoutAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthMeLogoutAll>>
>

export type PostAuthMeLogoutAllMutationError = unknown

/**
 * @summary Sign every device out
 */
export const usePostAuthMeLogoutAll = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthMeLogoutAll>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof postAuthMeLogoutAll>>, TError, void, TContext> => {
  return useMutation(getPostAuthMeLogoutAllMutationOptions(options), queryClient)
}
export const getPostAuthMeAvatarUrl = () => {
  return `/api/v1/auth/me/avatar`
}

/**
 * @summary Upload your portrait
 */
export const postAuthMeAvatar = async (
  postAuthMeAvatarBody?: PostAuthMeAvatarBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AvatarSet> => {
  return customFetch<AvatarSet>(getPostAuthMeAvatarUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAuthMeAvatarBody),
  })
}

export const getPostAuthMeAvatarMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAuthMeAvatar>>,
    TError,
    { data?: PostAuthMeAvatarBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAuthMeAvatar>>,
  TError,
  { data?: PostAuthMeAvatarBody },
  TContext
> => {
  const mutationKey = ['postAuthMeAvatar']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAuthMeAvatar>>,
    { data?: PostAuthMeAvatarBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAuthMeAvatar(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAuthMeAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAuthMeAvatar>>
>
export type PostAuthMeAvatarMutationBody = PostAuthMeAvatarBody | undefined
export type PostAuthMeAvatarMutationError = unknown

/**
 * @summary Upload your portrait
 */
export const usePostAuthMeAvatar = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAuthMeAvatar>>,
      TError,
      { data?: PostAuthMeAvatarBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAuthMeAvatar>>,
  TError,
  { data?: PostAuthMeAvatarBody },
  TContext
> => {
  return useMutation(getPostAuthMeAvatarMutationOptions(options), queryClient)
}
export const getDeleteAuthMeAvatarUrl = () => {
  return `/api/v1/auth/me/avatar`
}

/**
 * @summary Remove your portrait
 */
export const deleteAuthMeAvatar = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AvatarCleared> => {
  return customFetch<AvatarCleared>(getDeleteAuthMeAvatarUrl(), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteAuthMeAvatarMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAuthMeAvatar>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<Awaited<ReturnType<typeof deleteAuthMeAvatar>>, TError, void, TContext> => {
  const mutationKey = ['deleteAuthMeAvatar']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAuthMeAvatar>>, void> = () => {
    return deleteAuthMeAvatar(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteAuthMeAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAuthMeAvatar>>
>

export type DeleteAuthMeAvatarMutationError = unknown

/**
 * @summary Remove your portrait
 */
export const useDeleteAuthMeAvatar = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAuthMeAvatar>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof deleteAuthMeAvatar>>, TError, void, TContext> => {
  return useMutation(getDeleteAuthMeAvatarMutationOptions(options), queryClient)
}
export const getGetAttendanceUrl = (params?: GetAttendanceParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/attendance?${stringifiedParams}`
    : `/api/v1/attendance`
}

/**
 * @summary Attendance records
 */
export const getAttendance = async (
  params?: GetAttendanceParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceListRow[]> => {
  return customFetch<AttendanceListRow[]>(getGetAttendanceUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAttendanceQueryKey = (params?: GetAttendanceParams) => {
  return [`/api/v1/attendance`, ...(params ? [params] : [])] as const
}

export const getGetAttendanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendance>>,
  TError = unknown,
>(
  params?: GetAttendanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendance>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAttendanceQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendance>>> = ({ signal }) =>
    getAttendance(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttendanceQueryResult = NonNullable<Awaited<ReturnType<typeof getAttendance>>>
export type GetAttendanceQueryError = unknown

export function useGetAttendance<
  TData = Awaited<ReturnType<typeof getAttendance>>,
  TError = unknown,
>(
  params: undefined | GetAttendanceParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendance>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendance>>,
          TError,
          Awaited<ReturnType<typeof getAttendance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendance<
  TData = Awaited<ReturnType<typeof getAttendance>>,
  TError = unknown,
>(
  params?: GetAttendanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendance>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendance>>,
          TError,
          Awaited<ReturnType<typeof getAttendance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendance<
  TData = Awaited<ReturnType<typeof getAttendance>>,
  TError = unknown,
>(
  params?: GetAttendanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendance>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Attendance records
 */

export function useGetAttendance<
  TData = Awaited<ReturnType<typeof getAttendance>>,
  TError = unknown,
>(
  params?: GetAttendanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttendance>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAttendanceQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostAttendanceUrl = () => {
  return `/api/v1/attendance`
}

/**
 * @summary Record or amend a day
 */
export const postAttendance = async (
  postAttendanceBody: PostAttendanceBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceRecord> => {
  return customFetch<AttendanceRecord>(getPostAttendanceUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAttendanceBody),
  })
}

export const getPostAttendanceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttendance>>,
    TError,
    { data: PostAttendanceBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttendance>>,
  TError,
  { data: PostAttendanceBody },
  TContext
> => {
  const mutationKey = ['postAttendance']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttendance>>,
    { data: PostAttendanceBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAttendance(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAttendanceMutationResult = NonNullable<Awaited<ReturnType<typeof postAttendance>>>
export type PostAttendanceMutationBody = PostAttendanceBody
export type PostAttendanceMutationError = unknown

/**
 * @summary Record or amend a day
 */
export const usePostAttendance = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAttendance>>,
      TError,
      { data: PostAttendanceBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAttendance>>,
  TError,
  { data: PostAttendanceBody },
  TContext
> => {
  return useMutation(getPostAttendanceMutationOptions(options), queryClient)
}
export const getPostAttendanceSelfUrl = () => {
  return `/api/v1/attendance/self`
}

/**
 * @summary Clock yourself in or out
 */
export const postAttendanceSelf = async (
  postAttendanceSelfBody: PostAttendanceSelfBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendancePunched> => {
  return customFetch<AttendancePunched>(getPostAttendanceSelfUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAttendanceSelfBody),
  })
}

export const getPostAttendanceSelfMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttendanceSelf>>,
    TError,
    { data: PostAttendanceSelfBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttendanceSelf>>,
  TError,
  { data: PostAttendanceSelfBody },
  TContext
> => {
  const mutationKey = ['postAttendanceSelf']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttendanceSelf>>,
    { data: PostAttendanceSelfBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAttendanceSelf(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAttendanceSelfMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAttendanceSelf>>
>
export type PostAttendanceSelfMutationBody = PostAttendanceSelfBody
export type PostAttendanceSelfMutationError = unknown

/**
 * @summary Clock yourself in or out
 */
export const usePostAttendanceSelf = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAttendanceSelf>>,
      TError,
      { data: PostAttendanceSelfBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAttendanceSelf>>,
  TError,
  { data: PostAttendanceSelfBody },
  TContext
> => {
  return useMutation(getPostAttendanceSelfMutationOptions(options), queryClient)
}
export const getPostAttendanceDeviceUrl = () => {
  return `/api/v1/attendance/device`
}

/**
 * @summary A punch from the attendance terminal
 */
export const postAttendanceDevice = async (
  postAttendanceDeviceBody: PostAttendanceDeviceBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendancePunched> => {
  return customFetch<AttendancePunched>(getPostAttendanceDeviceUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAttendanceDeviceBody),
  })
}

export const getPostAttendanceDeviceMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAttendanceDevice>>,
    TError,
    { data: PostAttendanceDeviceBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAttendanceDevice>>,
  TError,
  { data: PostAttendanceDeviceBody },
  TContext
> => {
  const mutationKey = ['postAttendanceDevice']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAttendanceDevice>>,
    { data: PostAttendanceDeviceBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAttendanceDevice(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAttendanceDeviceMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAttendanceDevice>>
>
export type PostAttendanceDeviceMutationBody = PostAttendanceDeviceBody
export type PostAttendanceDeviceMutationError = unknown

/**
 * @summary A punch from the attendance terminal
 */
export const usePostAttendanceDevice = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAttendanceDevice>>,
      TError,
      { data: PostAttendanceDeviceBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAttendanceDevice>>,
  TError,
  { data: PostAttendanceDeviceBody },
  TContext
> => {
  return useMutation(getPostAttendanceDeviceMutationOptions(options), queryClient)
}
export const getPostAdminBackfillMarch30WaiterUrl = () => {
  return `/api/v1/admin/backfill-march30-waiter`
}

/**
 * @summary One-off: attribute six unassigned bar bills from 30 March 2026
 */
export const postAdminBackfillMarch30Waiter = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WaiterBackfillResult> => {
  return customFetch<WaiterBackfillResult>(getPostAdminBackfillMarch30WaiterUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostAdminBackfillMarch30WaiterMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAdminBackfillMarch30Waiter>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAdminBackfillMarch30Waiter>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postAdminBackfillMarch30Waiter']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAdminBackfillMarch30Waiter>>,
    void
  > = () => {
    return postAdminBackfillMarch30Waiter(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAdminBackfillMarch30WaiterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAdminBackfillMarch30Waiter>>
>

export type PostAdminBackfillMarch30WaiterMutationError = unknown

/**
 * @summary One-off: attribute six unassigned bar bills from 30 March 2026
 */
export const usePostAdminBackfillMarch30Waiter = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAdminBackfillMarch30Waiter>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAdminBackfillMarch30Waiter>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostAdminBackfillMarch30WaiterMutationOptions(options), queryClient)
}
export const getDeleteSettingsRolesKeyUrl = (
  key: string,
  params?: DeleteSettingsRolesKeyParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/settings/roles/${key}?${stringifiedParams}`
    : `/api/v1/settings/roles/${key}`
}

/**
 * @summary Delete a custom role, moving its people
 */
export const deleteSettingsRolesKey = async (
  key: string,
  params?: DeleteSettingsRolesKeyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteRoleResponse> => {
  return customFetch<DeleteRoleResponse>(getDeleteSettingsRolesKeyUrl(key, params), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteSettingsRolesKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSettingsRolesKey>>,
    TError,
    { key: string; params?: DeleteSettingsRolesKeyParams },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSettingsRolesKey>>,
  TError,
  { key: string; params?: DeleteSettingsRolesKeyParams },
  TContext
> => {
  const mutationKey = ['deleteSettingsRolesKey']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSettingsRolesKey>>,
    { key: string; params?: DeleteSettingsRolesKeyParams }
  > = (props) => {
    const { key, params } = props ?? {}

    return deleteSettingsRolesKey(key, params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteSettingsRolesKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSettingsRolesKey>>
>

export type DeleteSettingsRolesKeyMutationError = unknown

/**
 * @summary Delete a custom role, moving its people
 */
export const useDeleteSettingsRolesKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSettingsRolesKey>>,
      TError,
      { key: string; params?: DeleteSettingsRolesKeyParams },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSettingsRolesKey>>,
  TError,
  { key: string; params?: DeleteSettingsRolesKeyParams },
  TContext
> => {
  return useMutation(getDeleteSettingsRolesKeyMutationOptions(options), queryClient)
}
export const getPatchSettingsRolesKeyUrl = (key: string) => {
  return `/api/v1/settings/roles/${key}`
}

/**
 * @summary Rename, recolour, describe or re-order a custom role
 */
export const patchSettingsRolesKey = async (
  key: string,
  updateRoleRequest: UpdateRoleRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RoleView> => {
  return customFetch<RoleView>(getPatchSettingsRolesKeyUrl(key), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateRoleRequest),
  })
}

export const getPatchSettingsRolesKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchSettingsRolesKey>>,
    TError,
    { key: string; data: UpdateRoleRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchSettingsRolesKey>>,
  TError,
  { key: string; data: UpdateRoleRequest },
  TContext
> => {
  const mutationKey = ['patchSettingsRolesKey']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchSettingsRolesKey>>,
    { key: string; data: UpdateRoleRequest }
  > = (props) => {
    const { key, data } = props ?? {}

    return patchSettingsRolesKey(key, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchSettingsRolesKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchSettingsRolesKey>>
>
export type PatchSettingsRolesKeyMutationBody = UpdateRoleRequest
export type PatchSettingsRolesKeyMutationError = unknown

/**
 * @summary Rename, recolour, describe or re-order a custom role
 */
export const usePatchSettingsRolesKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchSettingsRolesKey>>,
      TError,
      { key: string; data: UpdateRoleRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchSettingsRolesKey>>,
  TError,
  { key: string; data: UpdateRoleRequest },
  TContext
> => {
  return useMutation(getPatchSettingsRolesKeyMutationOptions(options), queryClient)
}
export const getDeleteEmployeesIdUrl = (id: number) => {
  return `/api/v1/employees/${id}`
}

/**
 * @summary Remove an employee
 */
export const deleteEmployeesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteEmployeesIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteEmployeesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEmployeesId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEmployeesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteEmployeesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEmployeesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteEmployeesId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteEmployeesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEmployeesId>>
>

export type DeleteEmployeesIdMutationError = unknown

/**
 * @summary Remove an employee
 */
export const useDeleteEmployeesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEmployeesId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEmployeesId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteEmployeesIdMutationOptions(options), queryClient)
}
export const getPatchEmployeesIdUrl = (id: number) => {
  return `/api/v1/employees/${id}`
}

/**
 * @summary Change an employee
 */
export const patchEmployeesId = async (
  id: number,
  patchEmployeesIdBody: PatchEmployeesIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee> => {
  return customFetch<Employee>(getPatchEmployeesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchEmployeesIdBody),
  })
}

export const getPatchEmployeesIdMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchEmployeesId>>,
    TError,
    { id: number; data: PatchEmployeesIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchEmployeesId>>,
  TError,
  { id: number; data: PatchEmployeesIdBody },
  TContext
> => {
  const mutationKey = ['patchEmployeesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchEmployeesId>>,
    { id: number; data: PatchEmployeesIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchEmployeesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchEmployeesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchEmployeesId>>
>
export type PatchEmployeesIdMutationBody = PatchEmployeesIdBody
export type PatchEmployeesIdMutationError = unknown

/**
 * @summary Change an employee
 */
export const usePatchEmployeesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchEmployeesId>>,
      TError,
      { id: number; data: PatchEmployeesIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchEmployeesId>>,
  TError,
  { id: number; data: PatchEmployeesIdBody },
  TContext
> => {
  return useMutation(getPatchEmployeesIdMutationOptions(options), queryClient)
}
export const getPatchEmployeesIdApproveUrl = (id: number) => {
  return `/api/v1/employees/${id}/approve`
}

/**
 * @summary Approve an external driver
 */
export const patchEmployeesIdApprove = async (
  id: number,
  patchEmployeesIdApproveBody?: PatchEmployeesIdApproveBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee> => {
  return customFetch<Employee>(getPatchEmployeesIdApproveUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchEmployeesIdApproveBody),
  })
}

export const getPatchEmployeesIdApproveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchEmployeesIdApprove>>,
    TError,
    { id: number; data?: PatchEmployeesIdApproveBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchEmployeesIdApprove>>,
  TError,
  { id: number; data?: PatchEmployeesIdApproveBody },
  TContext
> => {
  const mutationKey = ['patchEmployeesIdApprove']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchEmployeesIdApprove>>,
    { id: number; data?: PatchEmployeesIdApproveBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchEmployeesIdApprove(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchEmployeesIdApproveMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchEmployeesIdApprove>>
>
export type PatchEmployeesIdApproveMutationBody = PatchEmployeesIdApproveBody | undefined
export type PatchEmployeesIdApproveMutationError = unknown

/**
 * @summary Approve an external driver
 */
export const usePatchEmployeesIdApprove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchEmployeesIdApprove>>,
      TError,
      { id: number; data?: PatchEmployeesIdApproveBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchEmployeesIdApprove>>,
  TError,
  { id: number; data?: PatchEmployeesIdApproveBody },
  TContext
> => {
  return useMutation(getPatchEmployeesIdApproveMutationOptions(options), queryClient)
}
export const getPatchEmployeesMyVehicleUrl = () => {
  return `/api/v1/employees/my-vehicle`
}

/**
 * @summary Choose the vehicle you are driving
 */
export const patchEmployeesMyVehicle = async (
  patchEmployeesMyVehicleBody: PatchEmployeesMyVehicleBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ChosenVehicle> => {
  return customFetch<ChosenVehicle>(getPatchEmployeesMyVehicleUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchEmployeesMyVehicleBody),
  })
}

export const getPatchEmployeesMyVehicleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchEmployeesMyVehicle>>,
    TError,
    { data: PatchEmployeesMyVehicleBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchEmployeesMyVehicle>>,
  TError,
  { data: PatchEmployeesMyVehicleBody },
  TContext
> => {
  const mutationKey = ['patchEmployeesMyVehicle']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchEmployeesMyVehicle>>,
    { data: PatchEmployeesMyVehicleBody }
  > = (props) => {
    const { data } = props ?? {}

    return patchEmployeesMyVehicle(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchEmployeesMyVehicleMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchEmployeesMyVehicle>>
>
export type PatchEmployeesMyVehicleMutationBody = PatchEmployeesMyVehicleBody
export type PatchEmployeesMyVehicleMutationError = unknown

/**
 * @summary Choose the vehicle you are driving
 */
export const usePatchEmployeesMyVehicle = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchEmployeesMyVehicle>>,
      TError,
      { data: PatchEmployeesMyVehicleBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchEmployeesMyVehicle>>,
  TError,
  { data: PatchEmployeesMyVehicleBody },
  TContext
> => {
  return useMutation(getPatchEmployeesMyVehicleMutationOptions(options), queryClient)
}
export const getPatchEmployeesMyAvailabilityUrl = () => {
  return `/api/v1/employees/my-availability`
}

/**
 * @summary Go on or off shift
 */
export const patchEmployeesMyAvailability = async (
  patchEmployeesMyAvailabilityBody: PatchEmployeesMyAvailabilityBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<DriverAvailability> => {
  return customFetch<DriverAvailability>(getPatchEmployeesMyAvailabilityUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchEmployeesMyAvailabilityBody),
  })
}

export const getPatchEmployeesMyAvailabilityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchEmployeesMyAvailability>>,
    TError,
    { data: PatchEmployeesMyAvailabilityBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchEmployeesMyAvailability>>,
  TError,
  { data: PatchEmployeesMyAvailabilityBody },
  TContext
> => {
  const mutationKey = ['patchEmployeesMyAvailability']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchEmployeesMyAvailability>>,
    { data: PatchEmployeesMyAvailabilityBody }
  > = (props) => {
    const { data } = props ?? {}

    return patchEmployeesMyAvailability(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchEmployeesMyAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchEmployeesMyAvailability>>
>
export type PatchEmployeesMyAvailabilityMutationBody = PatchEmployeesMyAvailabilityBody
export type PatchEmployeesMyAvailabilityMutationError = unknown

/**
 * @summary Go on or off shift
 */
export const usePatchEmployeesMyAvailability = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchEmployeesMyAvailability>>,
      TError,
      { data: PatchEmployeesMyAvailabilityBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchEmployeesMyAvailability>>,
  TError,
  { data: PatchEmployeesMyAvailabilityBody },
  TContext
> => {
  return useMutation(getPatchEmployeesMyAvailabilityMutationOptions(options), queryClient)
}
export const getGetAuthMeProfileUrl = () => {
  return `/api/v1/auth/me/profile`
}

/**
 * @summary Your own profile
 */
export const getAuthMeProfile = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffProfile> => {
  return customFetch<StaffProfile>(getGetAuthMeProfileUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthMeProfileQueryKey = () => {
  return [`/api/v1/auth/me/profile`] as const
}

export const getGetAuthMeProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthMeProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeProfile>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthMeProfileQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMeProfile>>> = ({ signal }) =>
    getAuthMeProfile({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthMeProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMeProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMeProfile>>>
export type GetAuthMeProfileQueryError = unknown

export function useGetAuthMeProfile<
  TData = Awaited<ReturnType<typeof getAuthMeProfile>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeProfile>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMeProfile>>,
          TError,
          Awaited<ReturnType<typeof getAuthMeProfile>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMeProfile<
  TData = Awaited<ReturnType<typeof getAuthMeProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeProfile>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMeProfile>>,
          TError,
          Awaited<ReturnType<typeof getAuthMeProfile>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMeProfile<
  TData = Awaited<ReturnType<typeof getAuthMeProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeProfile>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Your own profile
 */

export function useGetAuthMeProfile<
  TData = Awaited<ReturnType<typeof getAuthMeProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeProfile>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthMeProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchAuthMeProfileUrl = () => {
  return `/api/v1/auth/me/profile`
}

/**
 * @summary Change your own profile
 */
export const patchAuthMeProfile = async (
  patchAuthMeProfileBody: PatchAuthMeProfileBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffProfileUpdated> => {
  return customFetch<StaffProfileUpdated>(getPatchAuthMeProfileUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchAuthMeProfileBody),
  })
}

export const getPatchAuthMeProfileMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAuthMeProfile>>,
    TError,
    { data: PatchAuthMeProfileBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAuthMeProfile>>,
  TError,
  { data: PatchAuthMeProfileBody },
  TContext
> => {
  const mutationKey = ['patchAuthMeProfile']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAuthMeProfile>>,
    { data: PatchAuthMeProfileBody }
  > = (props) => {
    const { data } = props ?? {}

    return patchAuthMeProfile(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchAuthMeProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAuthMeProfile>>
>
export type PatchAuthMeProfileMutationBody = PatchAuthMeProfileBody
export type PatchAuthMeProfileMutationError = unknown

/**
 * @summary Change your own profile
 */
export const usePatchAuthMeProfile = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchAuthMeProfile>>,
      TError,
      { data: PatchAuthMeProfileBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchAuthMeProfile>>,
  TError,
  { data: PatchAuthMeProfileBody },
  TContext
> => {
  return useMutation(getPatchAuthMeProfileMutationOptions(options), queryClient)
}
export const getDeleteAttendanceIdUrl = (id: number) => {
  return `/api/v1/attendance/${id}`
}

/**
 * @summary Remove an attendance record
 */
export const deleteAttendanceId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceDeleted> => {
  return customFetch<AttendanceDeleted>(getDeleteAttendanceIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteAttendanceIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAttendanceId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAttendanceId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteAttendanceId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAttendanceId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteAttendanceId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteAttendanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAttendanceId>>
>

export type DeleteAttendanceIdMutationError = unknown

/**
 * @summary Remove an attendance record
 */
export const useDeleteAttendanceId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAttendanceId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAttendanceId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAttendanceIdMutationOptions(options), queryClient)
}
export const getPatchAttendanceIdUrl = (id: number) => {
  return `/api/v1/attendance/${id}`
}

/**
 * @summary Correct an attendance record
 */
export const patchAttendanceId = async (
  id: number,
  patchAttendanceIdBody: PatchAttendanceIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceRecord> => {
  return customFetch<AttendanceRecord>(getPatchAttendanceIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchAttendanceIdBody),
  })
}

export const getPatchAttendanceIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAttendanceId>>,
    TError,
    { id: number; data: PatchAttendanceIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAttendanceId>>,
  TError,
  { id: number; data: PatchAttendanceIdBody },
  TContext
> => {
  const mutationKey = ['patchAttendanceId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAttendanceId>>,
    { id: number; data: PatchAttendanceIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchAttendanceId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchAttendanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAttendanceId>>
>
export type PatchAttendanceIdMutationBody = PatchAttendanceIdBody
export type PatchAttendanceIdMutationError = unknown

/**
 * @summary Correct an attendance record
 */
export const usePatchAttendanceId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchAttendanceId>>,
      TError,
      { id: number; data: PatchAttendanceIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchAttendanceId>>,
  TError,
  { id: number; data: PatchAttendanceIdBody },
  TContext
> => {
  return useMutation(getPatchAttendanceIdMutationOptions(options), queryClient)
}
export const getGetAttendanceSelfTodayUrl = () => {
  return `/api/v1/attendance/self/today`
}

/**
 * @summary Your own attendance for today
 */
export const getAttendanceSelfToday = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceSelfToday> => {
  return customFetch<AttendanceSelfToday>(getGetAttendanceSelfTodayUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAttendanceSelfTodayQueryKey = () => {
  return [`/api/v1/attendance/self/today`] as const
}

export const getGetAttendanceSelfTodayQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendanceSelfToday>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfToday>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAttendanceSelfTodayQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendanceSelfToday>>> = ({ signal }) =>
    getAttendanceSelfToday({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendanceSelfToday>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttendanceSelfTodayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttendanceSelfToday>>
>
export type GetAttendanceSelfTodayQueryError = unknown

export function useGetAttendanceSelfToday<
  TData = Awaited<ReturnType<typeof getAttendanceSelfToday>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfToday>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceSelfToday>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceSelfToday>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceSelfToday<
  TData = Awaited<ReturnType<typeof getAttendanceSelfToday>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfToday>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceSelfToday>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceSelfToday>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceSelfToday<
  TData = Awaited<ReturnType<typeof getAttendanceSelfToday>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfToday>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Your own attendance for today
 */

export function useGetAttendanceSelfToday<
  TData = Awaited<ReturnType<typeof getAttendanceSelfToday>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfToday>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAttendanceSelfTodayQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPatchAttendanceSelfTodayUrl = () => {
  return `/api/v1/attendance/self/today`
}

/**
 * @summary Correct your own times for today
 */
export const patchAttendanceSelfToday = async (
  patchAttendanceSelfTodayBody: PatchAttendanceSelfTodayBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendancePunched> => {
  return customFetch<AttendancePunched>(getPatchAttendanceSelfTodayUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchAttendanceSelfTodayBody),
  })
}

export const getPatchAttendanceSelfTodayMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAttendanceSelfToday>>,
    TError,
    { data: PatchAttendanceSelfTodayBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAttendanceSelfToday>>,
  TError,
  { data: PatchAttendanceSelfTodayBody },
  TContext
> => {
  const mutationKey = ['patchAttendanceSelfToday']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAttendanceSelfToday>>,
    { data: PatchAttendanceSelfTodayBody }
  > = (props) => {
    const { data } = props ?? {}

    return patchAttendanceSelfToday(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchAttendanceSelfTodayMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAttendanceSelfToday>>
>
export type PatchAttendanceSelfTodayMutationBody = PatchAttendanceSelfTodayBody
export type PatchAttendanceSelfTodayMutationError = unknown

/**
 * @summary Correct your own times for today
 */
export const usePatchAttendanceSelfToday = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchAttendanceSelfToday>>,
      TError,
      { data: PatchAttendanceSelfTodayBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchAttendanceSelfToday>>,
  TError,
  { data: PatchAttendanceSelfTodayBody },
  TContext
> => {
  return useMutation(getPatchAttendanceSelfTodayMutationOptions(options), queryClient)
}
export const getGetSettingsRolesOptionsEmployeeIdUrl = (employeeId: number) => {
  return `/api/v1/settings/roles/options/${employeeId}`
}

/**
 * @summary The roles a person could be moved into, and what each move would do
 */
export const getSettingsRolesOptionsEmployeeId = async (
  employeeId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<RoleOptions> => {
  return customFetch<RoleOptions>(getGetSettingsRolesOptionsEmployeeIdUrl(employeeId), {
    ...options,
    method: 'GET',
  })
}

export const getGetSettingsRolesOptionsEmployeeIdQueryKey = (employeeId: number) => {
  return [`/api/v1/settings/roles/options/${employeeId}`] as const
}

export const getGetSettingsRolesOptionsEmployeeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetSettingsRolesOptionsEmployeeIdQueryKey(employeeId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>> = ({
    signal,
  }) => getSettingsRolesOptionsEmployeeId(employeeId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsRolesOptionsEmployeeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>
>
export type GetSettingsRolesOptionsEmployeeIdQueryError = unknown

export function useGetSettingsRolesOptionsEmployeeId<
  TData = Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
  TError = unknown,
>(
  employeeId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsRolesOptionsEmployeeId<
  TData = Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsRolesOptionsEmployeeId<
  TData = Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The roles a person could be moved into, and what each move would do
 */

export function useGetSettingsRolesOptionsEmployeeId<
  TData = Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>,
  TError = unknown,
>(
  employeeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSettingsRolesOptionsEmployeeId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSettingsRolesOptionsEmployeeIdQueryOptions(employeeId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesIdWaiterWalletUrl = (
  id: number,
  params?: GetEmployeesIdWaiterWalletParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/employees/${id}/waiter-wallet?${stringifiedParams}`
    : `/api/v1/employees/${id}/waiter-wallet`
}

/**
 * @summary One waiter's wallet, with the orders behind it
 */
export const getEmployeesIdWaiterWallet = async (
  id: number,
  params?: GetEmployeesIdWaiterWalletParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<WaiterWallet> => {
  return customFetch<WaiterWallet>(getGetEmployeesIdWaiterWalletUrl(id, params), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesIdWaiterWalletQueryKey = (
  id: number,
  params?: GetEmployeesIdWaiterWalletParams,
) => {
  return [`/api/v1/employees/${id}/waiter-wallet`, ...(params ? [params] : [])] as const
}

export const getGetEmployeesIdWaiterWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdWaiterWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesIdWaiterWalletQueryKey(id, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>> = ({
    signal,
  }) => getEmployeesIdWaiterWallet(id, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetEmployeesIdWaiterWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>
>
export type GetEmployeesIdWaiterWalletQueryError = unknown

export function useGetEmployeesIdWaiterWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>,
  TError = unknown,
>(
  id: number,
  params: undefined | GetEmployeesIdWaiterWalletParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesIdWaiterWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdWaiterWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesIdWaiterWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdWaiterWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One waiter's wallet, with the orders behind it
 */

export function useGetEmployeesIdWaiterWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdWaiterWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdWaiterWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesIdWaiterWalletQueryOptions(id, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesIdDriverWalletUrl = (
  id: number,
  params?: GetEmployeesIdDriverWalletParams,
) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/employees/${id}/driver-wallet?${stringifiedParams}`
    : `/api/v1/employees/${id}/driver-wallet`
}

/**
 * @summary One driver's wallet, with the orders behind it
 */
export const getEmployeesIdDriverWallet = async (
  id: number,
  params?: GetEmployeesIdDriverWalletParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DriverWallet> => {
  return customFetch<DriverWallet>(getGetEmployeesIdDriverWalletUrl(id, params), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesIdDriverWalletQueryKey = (
  id: number,
  params?: GetEmployeesIdDriverWalletParams,
) => {
  return [`/api/v1/employees/${id}/driver-wallet`, ...(params ? [params] : [])] as const
}

export const getGetEmployeesIdDriverWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdDriverWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesIdDriverWalletQueryKey(id, params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>> = ({
    signal,
  }) => getEmployeesIdDriverWallet(id, params, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetEmployeesIdDriverWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>
>
export type GetEmployeesIdDriverWalletQueryError = unknown

export function useGetEmployeesIdDriverWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>,
  TError = unknown,
>(
  id: number,
  params: undefined | GetEmployeesIdDriverWalletParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesIdDriverWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdDriverWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesIdDriverWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdDriverWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One driver's wallet, with the orders behind it
 */

export function useGetEmployeesIdDriverWallet<
  TData = Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>,
  TError = unknown,
>(
  id: number,
  params?: GetEmployeesIdDriverWalletParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesIdDriverWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesIdDriverWalletQueryOptions(id, params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesWalletsUrl = (params?: GetEmployeesWalletsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/employees/wallets?${stringifiedParams}`
    : `/api/v1/employees/wallets`
}

/**
 * @summary What every waiter and driver is carrying
 */
export const getEmployeesWallets = async (
  params?: GetEmployeesWalletsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<WalletSummary[]> => {
  return customFetch<WalletSummary[]>(getGetEmployeesWalletsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesWalletsQueryKey = (params?: GetEmployeesWalletsParams) => {
  return [`/api/v1/employees/wallets`, ...(params ? [params] : [])] as const
}

export const getGetEmployeesWalletsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesWallets>>,
  TError = unknown,
>(
  params?: GetEmployeesWalletsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWallets>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesWalletsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesWallets>>> = ({ signal }) =>
    getEmployeesWallets(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesWallets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesWalletsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesWallets>>
>
export type GetEmployeesWalletsQueryError = unknown

export function useGetEmployeesWallets<
  TData = Awaited<ReturnType<typeof getEmployeesWallets>>,
  TError = unknown,
>(
  params: undefined | GetEmployeesWalletsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWallets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesWallets>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesWallets>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesWallets<
  TData = Awaited<ReturnType<typeof getEmployeesWallets>>,
  TError = unknown,
>(
  params?: GetEmployeesWalletsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWallets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesWallets>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesWallets>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesWallets<
  TData = Awaited<ReturnType<typeof getEmployeesWallets>>,
  TError = unknown,
>(
  params?: GetEmployeesWalletsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWallets>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What every waiter and driver is carrying
 */

export function useGetEmployeesWallets<
  TData = Awaited<ReturnType<typeof getEmployeesWallets>>,
  TError = unknown,
>(
  params?: GetEmployeesWalletsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWallets>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesWalletsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesWaitersUrl = () => {
  return `/api/v1/employees/waiters`
}

/**
 * @summary Waiters currently on shift
 */
export const getEmployeesWaiters = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee[]> => {
  return customFetch<Employee[]>(getGetEmployeesWaitersUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesWaitersQueryKey = () => {
  return [`/api/v1/employees/waiters`] as const
}

export const getGetEmployeesWaitersQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesWaiters>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWaiters>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesWaitersQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesWaiters>>> = ({ signal }) =>
    getEmployeesWaiters({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesWaiters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesWaitersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesWaiters>>
>
export type GetEmployeesWaitersQueryError = unknown

export function useGetEmployeesWaiters<
  TData = Awaited<ReturnType<typeof getEmployeesWaiters>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWaiters>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesWaiters>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesWaiters>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesWaiters<
  TData = Awaited<ReturnType<typeof getEmployeesWaiters>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWaiters>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesWaiters>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesWaiters>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesWaiters<
  TData = Awaited<ReturnType<typeof getEmployeesWaiters>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWaiters>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Waiters currently on shift
 */

export function useGetEmployeesWaiters<
  TData = Awaited<ReturnType<typeof getEmployeesWaiters>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesWaiters>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesWaitersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesPerformanceUrl = (params?: GetEmployeesPerformanceParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/employees/performance?${stringifiedParams}`
    : `/api/v1/employees/performance`
}

/**
 * @summary Employee performance over a range
 */
export const getEmployeesPerformance = async (
  params?: GetEmployeesPerformanceParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<EmployeePerformance[]> => {
  return customFetch<EmployeePerformance[]>(getGetEmployeesPerformanceUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesPerformanceQueryKey = (params?: GetEmployeesPerformanceParams) => {
  return [`/api/v1/employees/performance`, ...(params ? [params] : [])] as const
}

export const getGetEmployeesPerformanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesPerformance>>,
  TError = unknown,
>(
  params?: GetEmployeesPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesPerformance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesPerformanceQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesPerformance>>> = ({
    signal,
  }) => getEmployeesPerformance(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesPerformance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesPerformanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesPerformance>>
>
export type GetEmployeesPerformanceQueryError = unknown

export function useGetEmployeesPerformance<
  TData = Awaited<ReturnType<typeof getEmployeesPerformance>>,
  TError = unknown,
>(
  params: undefined | GetEmployeesPerformanceParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesPerformance>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesPerformance>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesPerformance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesPerformance<
  TData = Awaited<ReturnType<typeof getEmployeesPerformance>>,
  TError = unknown,
>(
  params?: GetEmployeesPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesPerformance>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesPerformance>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesPerformance>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesPerformance<
  TData = Awaited<ReturnType<typeof getEmployeesPerformance>>,
  TError = unknown,
>(
  params?: GetEmployeesPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesPerformance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Employee performance over a range
 */

export function useGetEmployeesPerformance<
  TData = Awaited<ReturnType<typeof getEmployeesPerformance>>,
  TError = unknown,
>(
  params?: GetEmployeesPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesPerformance>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesPerformanceQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesMyWalletUrl = () => {
  return `/api/v1/employees/my-wallet`
}

/**
 * @summary Your own wallet
 */
export const getEmployeesMyWallet = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MyWallet> => {
  return customFetch<MyWallet>(getGetEmployeesMyWalletUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesMyWalletQueryKey = () => {
  return [`/api/v1/employees/my-wallet`] as const
}

export const getGetEmployeesMyWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesMyWallet>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyWallet>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesMyWalletQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesMyWallet>>> = ({ signal }) =>
    getEmployeesMyWallet({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesMyWallet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesMyWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesMyWallet>>
>
export type GetEmployeesMyWalletQueryError = unknown

export function useGetEmployeesMyWallet<
  TData = Awaited<ReturnType<typeof getEmployeesMyWallet>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyWallet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyWallet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyWallet>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyWallet<
  TData = Awaited<ReturnType<typeof getEmployeesMyWallet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyWallet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyWallet>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyWallet>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyWallet<
  TData = Awaited<ReturnType<typeof getEmployeesMyWallet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Your own wallet
 */

export function useGetEmployeesMyWallet<
  TData = Awaited<ReturnType<typeof getEmployeesMyWallet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyWallet>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesMyWalletQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesMyDeliveriesUrl = () => {
  return `/api/v1/employees/my-deliveries`
}

/**
 * @summary What you are carrying right now
 */
export const getEmployeesMyDeliveries = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DriverDelivery[]> => {
  return customFetch<DriverDelivery[]>(getGetEmployeesMyDeliveriesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesMyDeliveriesQueryKey = () => {
  return [`/api/v1/employees/my-deliveries`] as const
}

export const getGetEmployeesMyDeliveriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyDeliveries>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesMyDeliveriesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesMyDeliveries>>> = ({
    signal,
  }) => getEmployeesMyDeliveries({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesMyDeliveriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesMyDeliveries>>
>
export type GetEmployeesMyDeliveriesQueryError = unknown

export function useGetEmployeesMyDeliveries<
  TData = Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyDeliveries>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyDeliveries>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyDeliveries<
  TData = Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyDeliveries>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyDeliveries>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyDeliveries<
  TData = Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyDeliveries>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What you are carrying right now
 */

export function useGetEmployeesMyDeliveries<
  TData = Awaited<ReturnType<typeof getEmployeesMyDeliveries>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyDeliveries>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesMyDeliveriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesExternalDriversUrl = (params?: GetEmployeesExternalDriversParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/employees/external-drivers?${stringifiedParams}`
    : `/api/v1/employees/external-drivers`
}

/**
 * @summary External drivers with what they are owed
 */
export const getEmployeesExternalDrivers = async (
  params?: GetEmployeesExternalDriversParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ExternalDriver[]> => {
  return customFetch<ExternalDriver[]>(getGetEmployeesExternalDriversUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesExternalDriversQueryKey = (
  params?: GetEmployeesExternalDriversParams,
) => {
  return [`/api/v1/employees/external-drivers`, ...(params ? [params] : [])] as const
}

export const getGetEmployeesExternalDriversQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
  TError = unknown,
>(
  params?: GetEmployeesExternalDriversParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesExternalDrivers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesExternalDriversQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesExternalDrivers>>> = ({
    signal,
  }) => getEmployeesExternalDrivers(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesExternalDriversQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesExternalDrivers>>
>
export type GetEmployeesExternalDriversQueryError = unknown

export function useGetEmployeesExternalDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
  TError = unknown,
>(
  params: undefined | GetEmployeesExternalDriversParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesExternalDrivers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesExternalDrivers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesExternalDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
  TError = unknown,
>(
  params?: GetEmployeesExternalDriversParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesExternalDrivers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesExternalDrivers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesExternalDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
  TError = unknown,
>(
  params?: GetEmployeesExternalDriversParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesExternalDrivers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary External drivers with what they are owed
 */

export function useGetEmployeesExternalDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesExternalDrivers>>,
  TError = unknown,
>(
  params?: GetEmployeesExternalDriversParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesExternalDrivers>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesExternalDriversQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesDriversUrl = () => {
  return `/api/v1/employees/drivers`
}

/**
 * @summary Drivers available now
 */
export const getEmployeesDrivers = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Employee[]> => {
  return customFetch<Employee[]>(getGetEmployeesDriversUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesDriversQueryKey = () => {
  return [`/api/v1/employees/drivers`] as const
}

export const getGetEmployeesDriversQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesDrivers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDrivers>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesDriversQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesDrivers>>> = ({ signal }) =>
    getEmployeesDrivers({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesDrivers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesDriversQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesDrivers>>
>
export type GetEmployeesDriversQueryError = unknown

export function useGetEmployeesDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesDrivers>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDrivers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesDrivers>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesDrivers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesDrivers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDrivers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesDrivers>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesDrivers>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesDrivers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDrivers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Drivers available now
 */

export function useGetEmployeesDrivers<
  TData = Awaited<ReturnType<typeof getEmployeesDrivers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDrivers>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesDriversQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetEmployeesDriverStatsUrl = (params?: GetEmployeesDriverStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/employees/driver-stats?${stringifiedParams}`
    : `/api/v1/employees/driver-stats`
}

/**
 * @summary Kilometres driven, per driver and vehicle
 */
export const getEmployeesDriverStats = async (
  params?: GetEmployeesDriverStatsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DriverStats[]> => {
  return customFetch<DriverStats[]>(getGetEmployeesDriverStatsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesDriverStatsQueryKey = (params?: GetEmployeesDriverStatsParams) => {
  return [`/api/v1/employees/driver-stats`, ...(params ? [params] : [])] as const
}

export const getGetEmployeesDriverStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesDriverStats>>,
  TError = unknown,
>(
  params?: GetEmployeesDriverStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDriverStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesDriverStatsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesDriverStats>>> = ({
    signal,
  }) => getEmployeesDriverStats(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesDriverStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesDriverStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesDriverStats>>
>
export type GetEmployeesDriverStatsQueryError = unknown

export function useGetEmployeesDriverStats<
  TData = Awaited<ReturnType<typeof getEmployeesDriverStats>>,
  TError = unknown,
>(
  params: undefined | GetEmployeesDriverStatsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDriverStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesDriverStats>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesDriverStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesDriverStats<
  TData = Awaited<ReturnType<typeof getEmployeesDriverStats>>,
  TError = unknown,
>(
  params?: GetEmployeesDriverStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDriverStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesDriverStats>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesDriverStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesDriverStats<
  TData = Awaited<ReturnType<typeof getEmployeesDriverStats>>,
  TError = unknown,
>(
  params?: GetEmployeesDriverStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDriverStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Kilometres driven, per driver and vehicle
 */

export function useGetEmployeesDriverStats<
  TData = Awaited<ReturnType<typeof getEmployeesDriverStats>>,
  TError = unknown,
>(
  params?: GetEmployeesDriverStatsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesDriverStats>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesDriverStatsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuthMeStatsUrl = (params?: GetAuthMeStatsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/auth/me/stats?${stringifiedParams}`
    : `/api/v1/auth/me/stats`
}

/**
 * @summary Your own numbers for a range
 */
export const getAuthMeStats = async (
  params?: GetAuthMeStatsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffStats> => {
  return customFetch<StaffStats>(getGetAuthMeStatsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthMeStatsQueryKey = (params?: GetAuthMeStatsParams) => {
  return [`/api/v1/auth/me/stats`, ...(params ? [params] : [])] as const
}

export const getGetAuthMeStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthMeStats>>,
  TError = unknown,
>(
  params?: GetAuthMeStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthMeStatsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMeStats>>> = ({ signal }) =>
    getAuthMeStats(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthMeStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMeStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMeStats>>>
export type GetAuthMeStatsQueryError = unknown

export function useGetAuthMeStats<
  TData = Awaited<ReturnType<typeof getAuthMeStats>>,
  TError = unknown,
>(
  params: undefined | GetAuthMeStatsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMeStats>>,
          TError,
          Awaited<ReturnType<typeof getAuthMeStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMeStats<
  TData = Awaited<ReturnType<typeof getAuthMeStats>>,
  TError = unknown,
>(
  params?: GetAuthMeStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMeStats>>,
          TError,
          Awaited<ReturnType<typeof getAuthMeStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMeStats<
  TData = Awaited<ReturnType<typeof getAuthMeStats>>,
  TError = unknown,
>(
  params?: GetAuthMeStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Your own numbers for a range
 */

export function useGetAuthMeStats<
  TData = Awaited<ReturnType<typeof getAuthMeStats>>,
  TError = unknown,
>(
  params?: GetAuthMeStatsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthMeStatsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAuthMeActivityUrl = (params?: GetAuthMeActivityParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/auth/me/activity?${stringifiedParams}`
    : `/api/v1/auth/me/activity`
}

/**
 * @summary The last few things you did
 */
export const getAuthMeActivity = async (
  params?: GetAuthMeActivityParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffActivity> => {
  return customFetch<StaffActivity>(getGetAuthMeActivityUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAuthMeActivityQueryKey = (params?: GetAuthMeActivityParams) => {
  return [`/api/v1/auth/me/activity`, ...(params ? [params] : [])] as const
}

export const getGetAuthMeActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuthMeActivity>>,
  TError = unknown,
>(
  params?: GetAuthMeActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeActivity>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAuthMeActivityQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMeActivity>>> = ({ signal }) =>
    getAuthMeActivity(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuthMeActivity>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMeActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuthMeActivity>>
>
export type GetAuthMeActivityQueryError = unknown

export function useGetAuthMeActivity<
  TData = Awaited<ReturnType<typeof getAuthMeActivity>>,
  TError = unknown,
>(
  params: undefined | GetAuthMeActivityParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeActivity>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMeActivity>>,
          TError,
          Awaited<ReturnType<typeof getAuthMeActivity>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMeActivity<
  TData = Awaited<ReturnType<typeof getAuthMeActivity>>,
  TError = unknown,
>(
  params?: GetAuthMeActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeActivity>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMeActivity>>,
          TError,
          Awaited<ReturnType<typeof getAuthMeActivity>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMeActivity<
  TData = Awaited<ReturnType<typeof getAuthMeActivity>>,
  TError = unknown,
>(
  params?: GetAuthMeActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeActivity>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The last few things you did
 */

export function useGetAuthMeActivity<
  TData = Awaited<ReturnType<typeof getAuthMeActivity>>,
  TError = unknown,
>(
  params?: GetAuthMeActivityParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMeActivity>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAuthMeActivityQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAttendanceTodaySummaryUrl = () => {
  return `/api/v1/attendance/today-summary`
}

/**
 * @summary Everybody active, with today's attendance beside them
 */
export const getAttendanceTodaySummary = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceTodaySummary> => {
  return customFetch<AttendanceTodaySummary>(getGetAttendanceTodaySummaryUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAttendanceTodaySummaryQueryKey = () => {
  return [`/api/v1/attendance/today-summary`] as const
}

export const getGetAttendanceTodaySummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getAttendanceTodaySummary>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAttendanceTodaySummaryQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendanceTodaySummary>>> = ({
    signal,
  }) => getAttendanceTodaySummary({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttendanceTodaySummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttendanceTodaySummary>>
>
export type GetAttendanceTodaySummaryQueryError = unknown

export function useGetAttendanceTodaySummary<
  TData = Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceTodaySummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceTodaySummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceTodaySummary<
  TData = Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceTodaySummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceTodaySummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceTodaySummary<
  TData = Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceTodaySummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Everybody active, with today's attendance beside them
 */

export function useGetAttendanceTodaySummary<
  TData = Awaited<ReturnType<typeof getAttendanceTodaySummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceTodaySummary>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAttendanceTodaySummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAttendanceSelfHistoryUrl = (params?: GetAttendanceSelfHistoryParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/attendance/self/history?${stringifiedParams}`
    : `/api/v1/attendance/self/history`
}

/**
 * @summary Your own attendance over a range
 */
export const getAttendanceSelfHistory = async (
  params?: GetAttendanceSelfHistoryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceSelfHistory> => {
  return customFetch<AttendanceSelfHistory>(getGetAttendanceSelfHistoryUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAttendanceSelfHistoryQueryKey = (params?: GetAttendanceSelfHistoryParams) => {
  return [`/api/v1/attendance/self/history`, ...(params ? [params] : [])] as const
}

export const getGetAttendanceSelfHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
  TError = unknown,
>(
  params?: GetAttendanceSelfHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAttendanceSelfHistoryQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendanceSelfHistory>>> = ({
    signal,
  }) => getAttendanceSelfHistory(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttendanceSelfHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttendanceSelfHistory>>
>
export type GetAttendanceSelfHistoryQueryError = unknown

export function useGetAttendanceSelfHistory<
  TData = Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
  TError = unknown,
>(
  params: undefined | GetAttendanceSelfHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceSelfHistory>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceSelfHistory<
  TData = Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
  TError = unknown,
>(
  params?: GetAttendanceSelfHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceSelfHistory>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceSelfHistory<
  TData = Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
  TError = unknown,
>(
  params?: GetAttendanceSelfHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Your own attendance over a range
 */

export function useGetAttendanceSelfHistory<
  TData = Awaited<ReturnType<typeof getAttendanceSelfHistory>>,
  TError = unknown,
>(
  params?: GetAttendanceSelfHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceSelfHistory>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAttendanceSelfHistoryQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAttendanceMonthlyUrl = (params?: GetAttendanceMonthlyParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/attendance/monthly?${stringifiedParams}`
    : `/api/v1/attendance/monthly`
}

/**
 * @summary One month of attendance
 */
export const getAttendanceMonthly = async (
  params?: GetAttendanceMonthlyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AttendanceMonthly> => {
  return customFetch<AttendanceMonthly>(getGetAttendanceMonthlyUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAttendanceMonthlyQueryKey = (params?: GetAttendanceMonthlyParams) => {
  return [`/api/v1/attendance/monthly`, ...(params ? [params] : [])] as const
}

export const getGetAttendanceMonthlyQueryOptions = <
  TData = Awaited<ReturnType<typeof getAttendanceMonthly>>,
  TError = unknown,
>(
  params?: GetAttendanceMonthlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceMonthly>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAttendanceMonthlyQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttendanceMonthly>>> = ({ signal }) =>
    getAttendanceMonthly(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAttendanceMonthly>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttendanceMonthlyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAttendanceMonthly>>
>
export type GetAttendanceMonthlyQueryError = unknown

export function useGetAttendanceMonthly<
  TData = Awaited<ReturnType<typeof getAttendanceMonthly>>,
  TError = unknown,
>(
  params: undefined | GetAttendanceMonthlyParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceMonthly>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceMonthly>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceMonthly>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceMonthly<
  TData = Awaited<ReturnType<typeof getAttendanceMonthly>>,
  TError = unknown,
>(
  params?: GetAttendanceMonthlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceMonthly>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttendanceMonthly>>,
          TError,
          Awaited<ReturnType<typeof getAttendanceMonthly>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttendanceMonthly<
  TData = Awaited<ReturnType<typeof getAttendanceMonthly>>,
  TError = unknown,
>(
  params?: GetAttendanceMonthlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceMonthly>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One month of attendance
 */

export function useGetAttendanceMonthly<
  TData = Awaited<ReturnType<typeof getAttendanceMonthly>>,
  TError = unknown,
>(
  params?: GetAttendanceMonthlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAttendanceMonthly>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAttendanceMonthlyQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
